export default {"src":"/_next/static/media/strapi.e4741f5a.svg","height":252,"width":256,"blurWidth":0,"blurHeight":0};